import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamITIT() {
  return (
    <div className={styles["declaration"]}>
      <h1>Dichiarazione di Conformità per la Formazione e l'Esame dei Membri della Forza Operativa</h1>

      <p>
        Al fine di migliorare costantemente la qualità del servizio offerto dai promoter di terze parti in prima linea, il Team di Formazione del Dipartimento Internazionale di Xiaomi (di seguito denominato "noi" o "la nostra azienda") fornisce corsi di formazione ed esami di rafforzamento delle conoscenze per i promoter di terze parti (di seguito denominati "partecipanti") designati dai fornitori di servizi esterni. Lo scopo della formazione e dell'esame è ottimizzare i contenuti didattici e consolidare l'apprendimento senza costituire in alcun modo un rapporto di lavoro o un'attività di gestione effettiva. Di seguito si riportano le condizioni relative alla formazione e all’esame:
      </p>

      <ol>
        <li>
          <strong>Natura della formazione e dell'esame</strong><br/>
          Tutti i corsi di formazione e le prove di esame sono finalizzati alla condivisione delle conoscenze, con l'obiettivo di supportare i partecipanti nella comprensione sistematica delle informazioni sui prodotti, sugli standard di servizio, ecc. I risultati degli esami riflettono esclusivamente il livello di comprensione dei partecipanti rispetto ai contenuti formativi e non devono essere utilizzati come criterio per la valutazione delle prestazioni lavorative; La nostra azienda non ha alcuna autorità né interferisce nelle valutazioni delle prestazioni, nella definizione delle retribuzioni o in altre questioni relative al rapporto di lavoro dei partecipanti da parte dei fornitori di servizi esterni.
        </li>
        <li>
          <strong>Chiarimento del rapporto giuridico</strong><br/>
          Il rapporto datore di lavoro-dipendente tra i partecipanti e i rispettivi fornitori di servizi esterni rimane invariato e non viene in alcun modo modificato da questo programma di formazione e valutazione. Non sussiste alcun rapporto di lavoro diretto tra la nostra azienda e i partecipanti, né il programma di formazione e verifica costituisce la creazione di un tale rapporto.
        </li>
        <li>
          <strong>Utilizzo dei risultati degli esami</strong><br/>
          I risultati degli esami devono essere utilizzati solo per i seguenti scopi:
          <ol type="1">
            <li>Servire come riferimento interno per l'ottimizzazione e il miglioramento dei contenuti formativi dei corsi della nostra azienda;</li>
            <li>Servire come prova della competenza professionale dei partecipanti da fornire ai fornitori di servizi esterni, i quali ne valuteranno autonomamente l’utilizzo se vorranno;</li>
            <li>I risultati degli esami non saranno resi pubblici o divulgati a terzi.</li>
          </ol>
        </li>
      </ol>

      <p>
        La presente dichiarazione entrerà in vigore dalla data di pubblicazione. La partecipazione al programma di formazione e all'esame implica il riconoscimento e l'accettazione di questa dichiarazione da parte dei partecipanti. La nostra azienda si riserva il diritto finale di interpretazione e di apportare modifiche ragionevoli alla presente dichiarazione.
      </p>

      <div className={styles["footer"]}>
        Team di Formazione del Dipartimento Internazionale di Xiaomi<br/>
        Data: {getLocalizedTime('it-IT')}
      </div>
    </div>
  );
}